import { KYMW2000Model } from '../kymw2000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { OrderNumQuotaSelectedSummary } from '../vo/order-num-quota-selected-summary.model';

// レスポンス構造
interface GetCycleOrderNumQuotaSelectedSummaryResponse {
  SelectedNumList: {
    ClassCode: string,
    ClassName: string,
    IbarakiGoodsCount: number,
    TochigiGoodsCount: number,
    GunmaGoodsCount: number,
    ChibaGoodsCount: number,
    SaitamaGoodsCount: number,
    TokyoGoodsCount: number,
    NaganoGoodsCount: number,
    NiigataGoodsCount: number,
  }[],
  SelectedTotalNum: {
    IbarakiGoodsCount: number,
    TochigiGoodsCount: number,
    GunmaGoodsCount: number,
    ChibaGoodsCount: number,
    SaitamaGoodsCount: number,
    TokyoGoodsCount: number,
    NaganoGoodsCount: number,
    NiigataGoodsCount: number,
  },
  MaxNum: {
    IbarakiGoodsCount: number,
    TochigiGoodsCount: number,
    GunmaGoodsCount: number,
    ChibaGoodsCount: number,
    SaitamaGoodsCount: number,
    TokyoGoodsCount: number,
    NaganoGoodsCount: number,
    NiigataGoodsCount: number,
  },
}

/**
 * サイクル商品選定対象媒体一覧取得するサービス
 *
 * @export GetCycleOrderNumQuotaSelectedSummaryService
 * @class GetCycleOrderNumQuotaSelectedSummaryService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleOrderNumQuotaSelectedSummaryService extends PlessJsonResponderSub<any> {

  private model: KYMW2000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleOrderNumQuotaSelectedSummaryService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetCycleOrderNumQuotaSelectedSummary: {
          condition: {
            MediumType: this.model.mediumType,
            OrderCode: this.model.orderCode,
            OrderNumQuotaCode: this.model.orderNumQuota,
            MultiPublishFlg: this.model.multiPublishFlg,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCycleOrderNumQuotaSelectedSummaryService
   */
  execute(model: KYMW2000Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getCycleOrderNumQuotaSelectedSummary', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleOrderNumQuotaSelectedSummaryService
   */
  success(data: GetCycleOrderNumQuotaSelectedSummaryResponse): void {
    if (data !== null) {
      this.model.orderDeptRaw = [
        new OrderNumQuotaSelectedSummary(data.SelectedNumList, data.SelectedTotalNum, data.MaxNum)
      ];
      if (this.calbak) this.calbak();
    }
  }
}
